import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class Infrastructure extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Infrastructure
					</div>
					<div>
						<DownloadFile title="Download Infrastructure Dump" url="dump/space/infrastructure"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/space/infrastructure"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SpaceOperations/Components/Infrastructure.js